export function humanizeTeamId(teamId = '') {
  return String(teamId)
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function getTeamDisplayName(user = {}) {
  const schoolName = user?.schoolName?.trim?.() || '';
  const teamName = user?.teamName?.trim?.() || '';
  const teamId = user?.teamId || user?.teamID || '';
  const combinedName = [schoolName, teamName].filter(Boolean).join(' ');

  return combinedName || teamName || schoolName || humanizeTeamId(teamId) || 'Not set';
}
